interface Props {
    created: {
        createdAt: string
        hour: string
    }
    countRules: number
    chutesAssigned?: {
        totals: number
        notProcessed: number
    }
    isClassification?: boolean
}

export default function HeaderPatternDetail({
    created,
    chutesAssigned,
    countRules,
    isClassification = false,
}: Props) {
    return (
        <div className="w-full border border-[#E2E8F0] flex justify-between items-center px-4 py-4 bg-white rounded-xl">
            <div className="w-full">
                <p className="text-sm font-normal text-[#475569]">Creada el</p>
                <p className="text-base font-semibold text-[#070A13] mt-1">
                    {created.createdAt}
                </p>
                <p className="text-xs font-normal text-[#475569]">
                    {created.hour} hs
                </p>
            </div>
            <div className="w-px h-16 bg-gray-300 mx-[29px]" />
            <div className="w-full">
                <p className="text-sm font-normal text-[#475569]">Reglas</p>
                <p className="text-base font-semibold text-[#070A13] mt-1">
                    {countRules}
                </p>
                <p className="text-xs font-normal text-[#475569]">asignadas</p>
            </div>
            {!isClassification && chutesAssigned && (
                <>
                    <div className="w-px h-16 bg-gray-300 mx-[29px]" />
                    <div className="w-full">
                        <p className="text-sm font-normal text-[#475569]">Chutes asignados</p>
                        <div className="flex gap-8">
                            <div>
                                <p className="text-base font-semibold text-[#070A13] mt-1">{chutesAssigned.totals}</p>
                                <p className="text-xs font-normal text-[#475569]">totales</p>
                            </div>
                            <div>
                                <p className="text-base font-semibold text-[#070A13] mt-1">{chutesAssigned.notProcessed}</p>
                                <p className="text-xs font-normal text-[#475569]">restantes</p>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    )
}
